<template>
  <div class="edit">
    <Breadcrumb />
    <div class="edit-content">
      <div class="form-box">
        <moral-form></moral-form>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import StepAdd from "@/components/common/StepAdd.vue";
import MoralForm from "@/components/moralResearch/MoralForm.vue";
import LinkInfo from "@/components/common/LinkInfo.vue";
import LinkForm from "@/components/common/LinkForm.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState(["userInfo"]),
  },
  components: {
    Breadcrumb,
    StepAdd,
    MoralForm,
    LinkInfo,
    LinkForm,
  },
  data() {
    return {
      activeTab: "eduForm", // eduForm活动新增  link环节   linkAdd 环节新增
      isChangeTab: false, //是否可以切换 tab
      //环节类型
      linkInfo: {
        nodeType: "",
        nodeDesc: "",
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      sessionStorage.getItem("actCode") && (this.isChangeTab = true);
    },
    // changTab(code, linkInfo) {
    // 	this.linkInfo = linkInfo;
    // 	this.activeTab = code;
    // },
    // //下一步
    // changIsChangeTab(code) {
    // 	this.isChangeTab = code;
    // },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.edit {
  .edit-content {
    .step-box {
      margin-top: 15px;
      .step {
        background-color: #fff;
        height: 40px;
        text-align: center;
        font-size: 15px;
        line-height: 40px;
        font-weight: 700;
        color: @color;
      }
    }
    .form-box {
      margin-top: 15px;
      background-color: #fff;
    }
    .link-list {
      margin-top: 15px;
      background-color: #fff;
    }
    .link-edit {
      margin-top: 15px;
      background-color: #fff;
    }
  }
}
</style>